export default {
  loggedIn: false,
};
